var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-map-3d"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{ref:"container",staticClass:"canvas-container"},[_c('canvas',{ref:"canvas"})])])}
var staticRenderFns = []

export { render, staticRenderFns }